import type { FC } from 'react'
import { useEffect, useState } from 'react'

import { usePage } from '@app/shared/pagination'
import withSuspenseWrapper from '@app/shared/withSuspenseWrapper'
import { useStore } from '@app/store'
import { useTasksQuery } from '@graphql/queries'
import type { Task } from '@graphql/types'

interface Props {
  loading?: boolean
  setLoading?: (isLoading: boolean) => void
  limit?: number
  domainObjectType?: 'Metric'
  domainObjectId?: string
}

const TasksFetcher: FC<Props> = ({
  loading = false,
  setLoading = (_value) => {},
  limit = null,
  domainObjectId,
  domainObjectType
}) => {
  const addObjectPage = useStore.use.addObjectPage()
  const page = usePage()
  const [taskData, setTaskData] = useState(null)
  const [internalPage, setInternalPage] = useState(page)

  const variables: { page: number; limit?: number; domainObjectId?: string; domainObjectType?: 'Metric' } = { page }

  if (domainObjectId && domainObjectType) {
    variables.domainObjectId = domainObjectId
    variables.domainObjectType = domainObjectType
  }

  if (limit) {
    variables.limit = limit
  }

  const [{ data }] = useTasksQuery({
    variables,
    pause: !!taskData && page === internalPage
  })

  useEffect(() => {
    if (!loading && !data) {
      setLoading(true)
    }
  }, [data, loading, setLoading])

  useEffect(() => {
    if (!data) {
      return
    }

    const { collection = [], metadata } = data.tasks
    addObjectPage('task', collection as Task[], metadata)

    setInternalPage(page)
    setTaskData(data)
    setLoading(false)
  }, [loading, page, data, domainObjectId, domainObjectType, addObjectPage, setLoading])

  return null
}

export default withSuspenseWrapper(TasksFetcher)
